<template>
  <div class="flex w-full sm:w-1/2 md:1/3 lg:w-1/4">
    <div
      class="flex flex-col-reverse items-start w-full p-4 m-2 my-3 border rounded-lg shadow-md cursor-pointer hover:shadow-sm sm:items-center sm:flex-row"
    >
      <div class="w-full sm:w-3/4">
        <p class="w-full py-2 font-bold text-left text-md">
          {{ $props.item.name }}
        </p>
        <p class="w-full font-thin text-left">{{ $props.item.subCategory }}</p>
      </div>
      <div
        v-if="$props.item.images.length > 0"
        class="flex justify-center w-full sm:w-1/2"
      >
        <img
          :src="
            'https://d1y8zsubnbo9se.cloudfront.net/pictures/' +
            $props.item.images[0].id +
            '.' +
            $props.item.images[0].extension
          "
          class="flex-shrink object-scale-down h-32 max-w-full"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Item',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>
